export const locale = {
  lang: 'zh2',
  data: {
    'PORTAL': {
      'BTN_SCREE_SHO':'截图',
      'TOTALCOLA':'员工总数',
      'TOTALFAL':'尚未回应的员工',
      'TOTALCONT':'已经回复的员工',
      'TOTALPRO':'总进度',
      'TOTALLOG':'尚未完成调查的员工',
      'REPORTE':'建议的回应数量...',
      'RANKING':'的最低回应数...',
      'TOOLT_REPORTE':'通过人口统计学截止点提供统计上有意义的结果的建议响应次数',
      'TOOLT_RANKING':'公司认证/排名的最低回应数',

      'REPORTE_CER_CARCA':'建议的回复数...',
      'TOOLT_REPORTE_CER_CARCA':'考虑到每个选项将获得 5 个回复',
      'RANKING_CER_CARCA':'最少回复数...',
      'TOOLT_RANKING_CER_CARCA':'组织认证/排名的最低响应数',

      'REPORTE_MED_CARCA':'建议的回复数...',
      'TOOLT_REPORTE_MED_CARCA':'考虑到每个选项将获得 5 个回复',
      'RANKING_MED_CARCA':'最少回复数...',
      'TOOLT_RANKING_MED_CARCA':'组织认证/排名的最低响应数',

      'TOTALMIN':'最低员工人数',
      'SELECTFPLA':'过滤器',
      'TBARRAPROGRESO':'当前进度',
      'ACCESODENEGADO':'访问链接过期',
      'ACCESOMSJPRE_1': '调查的截止日期已到，此门户网站仍将有效 ',
      'ACCESOMSJPRE_2': '好的',
      'BTNOK': ' OK',
      'DIARESTA':'剩余的日子',
      'COLAB':'雇员',
      'PORTAL_V1':'计数门户 V1',
      'PORTAL_V2':'计数门户 V2',
      'NO-INFO':'协作者数据库中缺少的信息',
      'DI-TRANSCU':'天过去了',
      'ETI_GRAFI_ZONA_HO': '图中显示的日期设置为本地时间: ',
      'ETI_FILT_V1&V2': '标有（*）的组不显示信息，因为它们没有显示进度所需的最小用户数',
      'WAR_RESU_ARE_MIN5': '每个区域显示结果的最小响应数为5',
      'FILTROS':{
        '1': '国家',
        '2':'位置',
        '3':'区域部门',
        '4':'学历',
        '5':'部门',
        '6':'地理位置1级',
        '7':'地理级别2',
        '8':'地理级别3',
        '9':'地理级别4',
        '10':'地理5级',
        '11':'地理6级',
        '12':'地理7级',
        '13':'地理位置8级',
        '14':'地理9级',
        '15':'地理10级',
        '16':'结构级别1',
        '17':'结构级别2',
        '18':'3级结构',
        '19':'4级结构',
        '20':'5级结构',
        '21':'6级结构',
        '22':'7级结构',
        '23':'8级结构',
        '24':'9级结构',
        '25':'结构级别10',
        '26':'商业领域',
        '27':'结构级别2',
      },
      'COLUMNAS_TABLA':{
        'NIVEL1': '1 级',
        'NIVEL2': '2 级',
        'DEMOGRAFICO': '人口统计',
        'SEGMENTO': '分割',
        'COLABORADORES_T': '合作者总数',
        'PENDIENTES_RESPONDER': '尚未回应的协作者',
        'YA_RESPONDIERON': '已经回应的协作者',
        'AVANCE': '预习',
        'FILTERS': '筛选器'
      },
      'EXCEL_V2':{
        'TITULO_AVANCE': '实施调查的进展情况: ',
        'SHEET': '报告',
        'DESCARGA': '的计数门户 ',
        'MODAL_DESCARGA': '正确下载'
      },
      'ETIQUETAS':{
        'ETIQUETAS': '每页项目',
        'OF': '从',
        'BOTON':'重新启动过滤器'
      },
      'FILTROS_V2':{
        'ninguno': '没有',
        'Company': '公司',
        'country': '国家',
        'location': '位置',
        'area': '区',
        'antiquity': '资历',
        'generation': '代',
        'charge': '位置',
        'homologado': '职位批准',
        'gender': '性别',
        'typeofwork': '什么样的工作',
        'workCondition': '工作环境',
        'academico': '学位',
        'contratacion': '合同类型',
        'personal': '人员类型',
        'geo_1': '地理等级1',
        'geo_uno': '地理等级1',
        'geo_2': '地理等级2',
        'geo_3': '地理级别3',
        'geo_4': '地理等级4',
        'geo_5': '地理等级5',
        'geo_6':'地理6级',
        'geo_7':'地理7级',
        'geo_8':'地理位置8级',
        'geo_9':'地理9级',
        'geo_10':'地理10级',
        'structure_1': '结构一级',
        'structure_2': '结构等级2',
        'structure_3': '结构等级3',
        'structure_4': '结构等级4',
        'structure_5': '结构等级5',
        'structure_6': '结构等级6',
        'structure_7': '结构等级7',
        'structure_8': '结构等级8',
        'structure_9': '结构层9',
        'structure_10': '结构层10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': '结构一级',
        'structure_DOS': '结构等级2',
        'structure_TRES': '结构等级3',
        'structure_CUATRO': '结构等级4',
        'structure_CINCO': '结构等级5',
        'structure_SEIS': '结构等级6',
        'structure_SIETE': '结构等级7',
        'structure_OCHO': '结构等级8',
        'structure_NUEVE': '结构层9',
        'structure_DIEZ': '结构层10',
        'bUnit': '事业部',
      },
      'FILTROS_V2_HK':{
        'ninguno': '没有',
        'Company': '公司',
        'country': '国家',
        'location': '工作地点',
        'area': '部门',
        'antiquity': '资历',
        'generation': '代',
        'charge': '工作职位或职能',
        'homologado': '职位批准',
        'gender': '性别',
        'typeofwork': '什么样的工作',
        'workCondition': '工作状态',
        'academico': '学位',
        'contratacion': '合同类型',
        'personal': '人员类型',
        'geo_1': '地理等级1',
        'geo_uno': '地理等级1',
        'geo_2': '地理等级2',
        'geo_3': '地理级别3',
        'geo_4': '地理等级4',
        'geo_5': '地理等级5',
        'geo_6':'地理6级',
        'geo_7':'地理7级',
        'geo_8':'地理位置8级',
        'geo_9':'地理9级',
        'geo_10':'地理10级',
        'structure_1': '结构一级',
        'structure_2': '结构等级2',
        'structure_3': '结构等级3',
        'structure_4': '结构等级4',
        'structure_5': '结构等级5',
        'structure_6': '结构等级6',
        'structure_7': '结构等级7',
        'structure_8': '结构等级8',
        'structure_9': '结构层9',
        'structure_10': '结构层10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': '结构一级',
        'structure_DOS': '结构等级2',
        'structure_TRES': '结构等级3',
        'structure_CUATRO': '结构等级4',
        'structure_CINCO': '结构等级5',
        'structure_SEIS': '结构等级6',
        'structure_SIETE': '结构等级7',
        'structure_OCHO': '结构等级8',
        'structure_NUEVE': '结构层9',
        'structure_DIEZ': '结构层10',
        'bUnit': '事业部',
      },
      'PRODUCTO':{
        'CERT':'证明',
        'MED':'测量',
        'NOM35':'标准035',
        'PULSE':'检查',
        'FOCUS':'Focus Area',
        'MEDIR_1': '增强测量',
        'MEDIR_2': '测量+ MST',
        'MEDIR_3': '按区域测量',
        'MEDIR_4': '领导测量',
        'MEDIR_5': '按尺寸测量',
        'MEDIR_6': '认证措',
        'NAME':    '公司: ',
        'PRODUCTO':'产品： ',
        'PORTAL':'计数门户 ',
        'LEADER_GO':'Leader Go',
        'AMCO':'安科',
        'TRAB_DIGN':'体面的工作',
        'PRI_EMPLE':'第一份工作',
      },
      'EXCEL':{
        'NOMBOTON': '汇出Excel',
        'NOMBOTONREDUCIDO': '出口到Excel减少',
        'NOMEMPRE':'公司名',
        'NOMUSUARIO':'用户名',
        'NOMPROD':'产品名称',
        'FERTILITY':'发射日期',
        'FECHDESCA':'下载日期',
        'DRESTAN':'剩下的日子',
        'TOTALCOLA':'员工总数',
        'TOTALCONT':'已经响应的员工',
        'TOTALFAL':'尚未响应的员工',
        'TOTALPRO':'总进度',
        '报告':'可交付成果的响应率（最低85％）',
        'RANKING':'认证和排名示例',
        'FILT':'过滤',
        'NOMFILT':'过滤器名称',
        //pestaña校长
        'INFOGENE':'一般报告',
        'FILTROSNAME':{
          'country':	'国家',
          'location':	'位置',
          'area':	'区域',
          'antiquity':	'古代',
          'generation':	'代',
          'charge':	'收费',
          'homologado':	'homologado',
          'gender':	'性别',
          'typeofwork':	'什么样的工作',
          'workCondition':	'工作条件',
          'academico':	  'academico',
          'contratacion':	  '矛盾',
          'personal':	  '个人',
          'geo_1':	  ' geo 1',
          'geo_2':	  ' geo 2',
          'geo_3':	  ' geo 3',
          'geo_4':	  ' geo 4',
          'geo_5':	  '地理5',
          'structure_1':	  '结构1',
          'structure_2':	  '结构2',
          'structure_3':	  '结构3',
          'structure_4':	  '结构4',
          'structure_5':	  '结构5',
          'structure_6':	  '结构6',
          'structure_7':	  '结构7',
          'structure_8':	  '结构8',
          'structure_9':	  '结构9',
          'structure_10':	  '结构10',
        }

      },
      'TIPO-PERSONAL':{
        'TIPO':'个人类型',
        '1':'银团',
        '2':'相信',
        '3':'都',
      }

    },
    'PORTAL35': {
      'TOTALCOLA':'员工总数',
      'TOTALFAL': '还没有回复的员工',
      'TOTALCONT':'已经回复的员工',
      'TOTALPRO': '样本',
      'SELECTFPLA': '工作中心',
      'TBARRAPROGRESO':'总进度',
      'TOTALLOG':'未完成调查的员工',
      'TOTALGONE':'决定不回答的人',
      'FILTROS':{
        '1': "工作中心",
        '2': '国家',
        '3': '位置',
        '4': '面积',
        '5': '学历',
        '6': '部门',
        '7': '地理级别 1',
        '8': '地理级别 2',
        '9': '地理级别 3',
        '10': '地理等级 4',
        '11': '结构级别 1',
        '12': '结构级别 2',
        '13': '结构级别 3',
        '14': '地理级别 8',
        '15': '地理等级9',
        '16': '地理级别 10',
        '17': '等级 1',
        '18': '等级 2',
        '19': '等级 3',
        '20': '层级 4',
        '21': '等级 5',
        '22': '层级 6',
        '23': '层级 7',
        '24': '层级 8',
        '25': '等级 9',
        '26': '等级 10',
      }

    },
    'BTN':{
      'USERS':'合作者'
    }
  }
};
